import React, { useEffect, useState, useRef } from 'react'
import { Link, useMatch } from 'react-router-dom'
function UpdateItInfoComp() {
	let SERVER_URL = process.env.REACT_APP_API_URL;
	let token = JSON.parse(localStorage.getItem('key'));
	const match = useMatch("/:firstRoute/:id/*");
	var id = match.params.id;
	let user_login_id = localStorage.getItem('userId')
	const peremailRef = useRef();

	const[subdepartment,setSubepartment] = useState('');
	const[department,setDepartment] = useState('');
	const[skill,setSkill] = useState('');
	const[usercode,setUsercode] = useState('');
	const [name, setName] = useState('')
	const [email, setEmail] = useState('');
	const [email1, setEmail1] = useState('');
	const [password, setPassword] = useState('')
	const [personal, setPersonal] = useState('')
	const [contact_no, setContact_no] = useState('')
	const [itemailstatus, setItemailstatus] = useState(0)
	const [err, setErr] = useState('');
	const [errMsgemail, setErrMsgemail] = useState('');
	const [msg, setMsg] = useState('');

	useEffect(() => {
		getLoginDetails(id)
		getsystemallocated(id)
	}, [])
	const getsystemallocated = (id) => {
		fetch(SERVER_URL + `api/it/getAllocatedsysytem?userId=${id}`, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'authorization': `bearer ${token.value}`
			}
		}).then(res => res.json()).then(data => {
			var result = data.result;

			setPurchagetype(result.purchage_type)
			setSystemtype(result.system_type)
			setCompany(result.company_type)
			setOstype(result.os_type)
			setOfficetype(result.office_type)
			setModel(result.model_number)
			setSerialnumber(result.serial_number)
			setHost(result.host_name)
			setAssettag(result.asset_tag)
			setProcessor(result.processor)
			setHarddrive(result.hard_drive)
			setMemory1(result.memory_one)
			setMemory2(result.memory_two)
			setdataArray(result.accessories.split(','))

		})
	}
	const getLoginDetails = (id) => {
		const response = fetch(SERVER_URL + `api/it/getUserLogin?userId=${id}`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},

			}).then(res => res.json())
			.then(data => {
				if (data.status == true) {
					// console.log(data)
					setSkill(data.result?.skill)
					setSubepartment(data.result?.sub_dept_name)
					setDepartment(data.result?.dept_name)
					setUsercode(data.result?.user_code)
					setName(data.result?.name)
					setEmail(data.result?.email)
					setEmail1(data.result?.email)
					setPassword(data.result?.password)
					setPersonal(data.result?.personal_email)
					setContact_no(data.result?.contact_no)
					setItemailstatus(data.result?.official_email_status)

				} else {

				}

			})
	}

	const handleUpdate = () => {
		let regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
		let regpass = /^[a-zA-Z0-9]+([a-zA-Z0-9](_|-| )[a-zA-Z0-9])*[a-zA-Z0-9]+$/;
		if (!regEmail.test(email)) {
			setErr('red')
			setErrMsgemail('This field is required')
			peremailRef.current.focus();
			return false;
		}
		else {
			const response = fetch(SERVER_URL + `api/it/update-official-email`,
				{
					method: 'POST',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'authorization': `bearer ${token.value}`
					},
					body: JSON.stringify({
						EmpID: id,
						email: email,
						password: password,
						requestedBY: user_login_id
					}),
				}).then(res => res.json())
				.then(data => {
					if (data.status == true) {
						setMsg(data.msg)
						setErr('green')

						getLoginDetails(id)
						setTimeout(function () {
							setMsg('')
							setErr('')
						}, 1000);
					} else {
						setMsg('Error! something went wrong')
						setErr('red')
					}

				})
		}
	}

	const [systemStatus, setSystemStatus] = useState(0)

	const handleSystemStatus = (e) => {
		setSystemStatus(e.target.value)
		alert(systemStatus)
	}

	const [color, setColor] = useState('')

	const [purchagetype, setPurchagetype] = useState('')
	const [systemtype, setSystemtype] = useState('')
	const [company, setCompany] = useState('')
	const [ostype, setOstype] = useState('')
	const [officetype, setOfficetype] = useState('')
	const [model, setModel] = useState('')
	const [serialnumber, setSerialnumber] = useState('')
	const [host, setHost] = useState('')
	const [assettag, setAssettag] = useState('')
	const [processor, setProcessor] = useState('')
	const [harddrive, setHarddrive] = useState('')
	const [memory1, setMemory1] = useState('')
	const [memory2, setMemory2] = useState('')
	const AllocateSystem = () => {
		fetch(SERVER_URL + 'api/it/allocatesystem', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'authorization': `bearer ${token.value}`
			},
			body: JSON.stringify({
				user_id: id,
				purchagetype: purchagetype,
				systemtype: systemtype,
				company: company,
				ostype: ostype,
				officetype: officetype,
				model: model,
				serialnumber: serialnumber,
				host: host,
				assettag: assettag,
				processor: processor,
				harddrive: harddrive,
				memory1: memory1,
				memory2: memory2,
				accessories: accessories,
				status: 1
			})
		}).then(res => res.json()).then(data => {

			if (data.status == true) {
				setColor('green')
				setMsg(data.msg)

				setTimeout(function () {
					getsystemallocated(id)
					setMsg('')
				}, 1000);
			} else {

			}
		})


	}

	const [dataArray, setdataArray] = useState([]);
	const toggleHandler = (e) => {
		if (e.target.checked === true) {
			setdataArray([...dataArray, e.target.value]);
		}
		else if (e.target.checked === false) {
			let freshArray = dataArray.filter(val => val !== e.target.value);
			setdataArray([...freshArray]);
		}
	}
	var accessories = dataArray.toString();

	return (
		<>

			<div id="content_area">
				<div className="page-header">
					<h1>Update Info</h1>
					<ul id="breadcrumbs" className="breadcrumb mb00">
						<li>
							<Link to="/dashboard">Dashboard </Link>
						</li>
						<li>
							<Link to="/updateemail"><span>/</span> Onboarding List </Link>
						</li>
						<li className="current">
							<span>/</span> System Allocate
						</li>
					</ul>
				</div>
				<div className="row_bg">
					<div className="user_details_wrp">
						<div className="row">
							<div className="col-md-4">
								<div className="profile_detail">
									<div className="pic_user_details">
										<img src="../images/5.png" alt="" />
									</div>
									<div className="name_user_details">
										<div className="pro_title">{name} [{usercode?usercode:'N/A'}]</div>
										<div className="pro_sub_head">{department?department:'N/A'}</div>
										<div className="pro_sub_head">{subdepartment?subdepartment:'N/A'}</div>
										<div className="pro_sub_head">{skill?skill:'N/A'}</div>
									</div>
								</div>
							</div>
							<div className="col-md-8">
								<div className="row">
									<div className="col-md-6">
										<div className="pro_blk pt10">
											<div className="pro_heading">Phone Number</div>
											<div className="pro_sub_head">
												<i className="icon icon-telephone2 mr05"></i>
												{contact_no ? contact_no : 'N/A'}
											</div>
										</div>
										<div className="pro_blk">
											<div className="pro_heading">Email</div>
											<div className="pro_sub_head">
												<i className="icon icon-envelope mr05"></i>
												{email1 ? email1 : 'N/A'}
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="pro_blk">
											<div className="pro_heading">Date of Joining</div>
											<div className="pro_sub_head">
												<i className="icon icon-calendar-full mr05"></i>
												26 July, 2021
											</div>
										</div>
										<div className="pro_blk">
											<div className="pro_heading">Reporting Manager</div>
											<div className="pro_sub_head">Pallavi Verma</div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
					<div className="dash_white_box2">
						<div className="row mb10">
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Purchase Type</div>
									<div className="form-input">
										<select value={purchagetype} onChange={e => { setPurchagetype(e.target.value) }} className="form-select">
											<option value=''>Select Purchase Type</option>
											<option value='1'>Own</option>
											<option value='2'>Rented</option>
										</select>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">System Type</div>
									<div className="form-input">
										<select value={systemtype} onChange={e => { setSystemtype(e.target.value) }} className="form-select">
											<option value=''>Select System</option>
											<option value='2'>Desktop</option>
											<option value='3'>Laptop</option>
										</select>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Company</div>
									<div className="form-input">
										<select value={company} onChange={e => { setCompany(e.target.value) }} className="form-select">
											<option value=''>Select Company</option>
											<option value='1'>APPLE</option>
											<option value='2'>DELL</option>
											<option value='3'>LENOVO</option>
											<option value='4'>HP</option>
											<option value='5'>SAMSUNG</option>
											<option value='6'>ASUS</option>
											<option value='7'>ACER</option>
											<option value='8'>LG</option>
											<option value='9'>MSI</option>
											<option value='10'>MICROSOFT</option>
											<option value='11'>ASSEBLED</option>
										</select>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">OS Type</div>
									<div className="form-input">
										<select value={ostype} onChange={e => { setOstype(e.target.value) }} className="form-select">
											<option value=''>Select Company</option>
											<option value='1'>Windows</option>
											<option value='2'>GNU/Linux</option>
											<option value='3'>macOS</option>
											<option value='4'>HP</option>
										</select>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Office Type</div>
									<div className="form-input">
										<select value={officetype} onChange={e => { setOfficetype(e.target.value) }} className="form-select">
											<option value=''>Select Company</option>
											<option value='1'>Office</option>
											<option value='2'>Office</option>
											<option value='3'>Office</option>
											<option value='4'>Office</option>

										</select>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Modal</div>
									<div className="form-input">
										<input type="text" value={model} onChange={e => { setModel(e.target.value) }} placeholder="Enter modal number" className="form-control form-control1" />
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Serial Number</div>
									<div className="form-input">
										<input type="text" value={serialnumber} onChange={e => { setSerialnumber(e.target.value) }} placeholder="Enter serial number" className="form-control form-control1" />
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Host Name</div>
									<div className="form-input">
										<input type="text" value={host} onChange={e => { setHost(e.target.value) }} placeholder="Enter host name" className="form-control form-control1" />
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Asset Tag</div>
									<div className="form-input">
										<input type="text" value={assettag} onChange={e => { setAssettag(e.target.value) }} placeholder="Enter asset tag" className="form-control form-control1" />
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Processor</div>
									<div className="form-input">
										<select value={processor} onChange={e => { setProcessor(e.target.value) }} className="form-select">
											<option value=''>Select</option>
											<option value='1'>Processor</option>
											<option value='2'>Processor</option>
											<option value='3'>Processor</option>
										</select>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Hard Drive</div>
									<div className="form-input">
										<select value={harddrive} onChange={e => { setHarddrive(e.target.value) }} className="form-select">
											<option value=''>Select</option>
											<option value='1'>Hard Driv</option>
											<option value='2'>Hard Driv</option>
											<option value='3'>Hard Driv</option>
											<option value='4'>Hard Driv</option>
										</select>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Memory One</div>
									<div className="form-input">
										<select value={memory1} onChange={e => { setMemory1(e.target.value) }} className="form-select">
											<option value=''>Select</option>
											<option value='1'>1 GB</option>
											<option value='2'>2 GB</option>
											<option value='3'>3 GB</option>
										</select>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-blk mb15">
									<div className="form-label mb10">Memory Two</div>
									<div className="form-input">
										<select value={memory2} onChange={e => { setMemory2(e.target.value) }} className="form-select">
											<option value=''>Select</option>
											<option value='1'>1 GB</option>
											<option value='2'>2 GB</option>
											<option value='3'>3 GB</option>
										</select>
									</div>
								</div>
							</div>


							<div className="col-md-12">
								<div className="form-blk mb15">
									<div className="form-label mb10">Accessories</div>
									<div className="form-input">
										<div className="form-check formcheck1 mt00">
											<input onChange={toggleHandler} checked={dataArray.includes('1')} className="form-check-input" type="checkbox" value="1" id="access1" />
											<label className="form-check-label" htmlFor="access1">
												Keyboard
											</label>
										</div>
										<div className="form-check formcheck1 mt00">
											<input onChange={toggleHandler} checked={dataArray.includes('2')} className="form-check-input" type="checkbox" value="2" id="access2" />
											<label className="form-check-label" htmlFor="access2">
												Laptop
											</label>
										</div>
										<div className="form-check formcheck1 mt00">
											<input onChange={toggleHandler} checked={dataArray.includes('3')} className="form-check-input" type="checkbox" value="3" id="access3" />
											<label className="form-check-label" htmlFor="access3">
												Mouse
											</label>
										</div>
										<div className="form-check formcheck1 mt00">
											<input onChange={toggleHandler} checked={dataArray.includes('4')} className="form-check-input" type="checkbox" value="4" id="access4" />
											<label className="form-check-label" htmlFor="access4">
												Bag
											</label>
										</div>
										<div className="form-check formcheck1 mt00">
											<input onChange={toggleHandler} checked={dataArray.includes('5')} className="form-check-input" type="checkbox" value="5" id="access5" />
											<label className="form-check-label" htmlFor="access5">
												Tablet
											</label>
										</div>
										{/* <div className="form-check formcheck1 mt00">
											<input onChange={toggleHandler} className="form-check-input" type="checkbox" value="6" id="access6" />
											<label className="form-check-label" htmlFor="access6">
												Email Deletion
											</label>
										</div> */}
									</div>
								</div>
							</div>
						</div>
						<div className="text-end">
							<div style={{ color: color }}>{msg}</div>
							<button className="btn_5" onClick={AllocateSystem}>Save</button>
							<button className="btn_6 ml10">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default UpdateItInfoComp
